@if (isRmbRmc) {
<div>
  <span>
    {{ staticText | globalTranslate }}
  </span>
</div>
} @if (isRmbRmc && this.selectedIndividual) {
<div>
  <br />
</div>
} @if ((getValue('extras.topLevelAnswer') === 'YES') &&
(this.selectedIndividual)) {
<div form-top>
  <p class="person-label">{{ selectedIndividual | fullname }}</p>
</div>
}<br />
<nh-form
  [topLevelName]="'ve'"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="label-section"
  topLevelQuestion="{{ 'VEHICLE_TOPLEVEL_QUESTION' | globalTranslate }}"
  popupText="{{ 'VEHICLE_TOPLEVEL_POPUP' | globalTranslate }}"
  individualQuestion="{{ 'VEHICLE_INDIVIDUAL_QUESTION' | globalTranslate }}"
  hintText="{{ hintText }}"
  (validate)="onValidate($event)"
  (individualAnswerChanged)="onIndividualChange($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "VEHICLE_STATIC_TEXT1" | globalTranslate }}
    </h1>
    <hr />

    <nh-field
      id="ve_assetType"
      label="{{ 'VEHICLE_STATIC_TEXT2' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'VEHICLE_STATIC_TEXT3' | globalTranslate }} <div class=hint>{{
        'IF' | globalTranslate
      }} {{ selectedIndividual | fullname }} {{
        'VEHICLE_STATIC_TEXT4' | globalTranslate
      }} <b>{{ 'VEHICLE_STATIC_TEXT4_01' | globalTranslate }}</b>.</div>"
      class="label-section"
    >
      <select
        nhTranslate
        name="assetType"
        aria-required="true"
        [attr.aria-label]="
          ('VEHICLE_STATIC_TEXT2' | globalTranslate) +
          '' +
          (selectedIndividual | fullname) +
          '' +
          ('VEHICLE_STATIC_TEXT3' | globalTranslate)
        "
        [items]="tableCodeValue('MPVEHICLETYPE', 'data.assetType')"
        formControlName="assetType"
      ></select>
    </nh-field>

    <nh-field
      id="ve_vehicleYear"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'YEAR' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="vehicleYear"
        [attr.aria-label]="'YEAR' | globalTranslate"
        formControlName="vehicleYear"
        class="form-control"
        mask="0*"
        maxlength="4"
        placeholder="YYYY"
      />
    </nh-field>

    <nh-field
      id="ve_vehicleMake"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'VEHICLE_STATIC_TEXT5' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="vehicleMake"
        [attr.aria-label]="'VEHICLE_STATIC_TEXT5' | globalTranslate"
        formControlName="vehicleMake"
        maxlength="25"
        class="form-control"
      />
    </nh-field>

    <nh-field
      id="ve_vehicleModel"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'VEHICLE_STATIC_TEXT6' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="vehicleModel"
        [attr.aria-label]="'VEHICLE_STATIC_TEXT6' | globalTranslate"
        formControlName="vehicleModel"
        maxlength="25"
        class="form-control"
      />
    </nh-field>

    <nh-field
      id="ve_vehicleUsage"
      label="{{ 'VEHICLE_STATIC_TEXT7' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'VEHICLE_STATIC_TEXT8' | globalTranslate }} {{
        getValue('data.assetType').value | globalTranslate
      }}?"
      class="label-section"
    >
      <select
        nhTranslate
        name="vehicleUsage"
        aria-required="true"
        [attr.aria-label]="
          ('VEHICLE_STATIC_TEXT7' | globalTranslate) +
          '' +
          (selectedIndividual | fullname) +
          '' +
          ('VEHICLE_STATIC_TEXT8' | globalTranslate) +
          '' +
          (getValue('data.assetType').value | globalTranslate)
        "
        [items]="tableCodeValue('VEHICLEUSE', 'data.vehicleUsage')"
        formControlName="vehicleUsage"
      ></select>
    </nh-field>

    <nh-field
      id="ve_owedAmount"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'VEHICLE_STATIC_TEXT9' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'VEHICLE_STATIC_TEXT10' | globalTranslate }} {{
        getValue('data.assetType').value | globalTranslate
      }}? "
      class="label-section"
    >
      <div class="hint">{{ "VEHICLE_STATIC_TEXT11" | globalTranslate }}</div>
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          [attr.aria-label]="
            ('VEHICLE_STATIC_TEXT9' | globalTranslate) +
            '' +
            (selectedIndividual | fullname) +
            '' +
            ('VEHICLE_STATIC_TEXT10' | globalTranslate) +
            '' +
            (getValue('data.assetType').value | globalTranslate)
          "
          maxlength="7"
          name="owedAmount"
          formControlName="owedAmount"
          class="form-control"
        />
      </nh-input-group>
    </nh-field>

    <nh-field
      id="ve_assetAmount"
      label="{{ 'VEHICLE_STATIC_TEXT12' | globalTranslate }} "
      class="label-section"
    >
      <div class="hint">{{ "VEHICLE_STATIC_TEXT13" | globalTranslate }}</div>
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          id="ve_assetAmount"
          aria-required="true"
          [attr.aria-label]="
            ('VEHICLE_STATIC_TEXT12' | globalTranslate) +
            ' ' +
            ('required' | globalTranslate)
          "
          maxlength="7"
          name="assetAmount"
          formControlName="assetAmount"
          class="form-control"
          placeholder="0.00"
          [attr.aria-placeholder]="'0.00'"
        />
      </nh-input-group>
    </nh-field>

    <br />
    <div (window:resize)="onResize($event)"></div>
    @if (selectedIndividual) {
    <div>
      <h2 class="section-header">{{ "CO-OWENERS_TITLE" | globalTranslate }}</h2>
      <hr />
      <nh-field
        id="ve_jointOwnership"
        label="{{ 'VEHICLE_STATIC_TEXT14' | globalTranslate }} {{
          getValue('data.assetType').value | globalTranslate
        }} {{ 'VEHICLE_STATIC_TEXT15' | globalTranslate }} {{
          selectedIndividual | fullname
        }}? "
        class="label-section"
      >
        <div class="hint">
          {{ "VEHICLE_STATIC_TEXT16" | globalTranslate }}
          {{ selectedIndividual | fullname }}
          {{ "VEHICLE_STATIC_TEXT17" | globalTranslate }}
        </div>
        <select
          nhTranslate
          name="jointOwnership"
          [attr.aria-label]="
            ('VEHICLE_STATIC_TEXT14' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value | globalTranslate) +
            ' ' +
            ('VEHICLE_STATIC_TEXT15' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname)
          "
          [items]="tableCodeValue('YESNO', 'data.jointOwnership')"
          formControlName="jointOwnership"
          aria-required="true"
        ></select>
      </nh-field>
      @if (isY('data.jointOwnership')) {
      <div>
        <nh-co-owner
          [jointOwnershipInformation]="
            getControl('data.jointOwnershipInformation')
          "
          [formData]="getControl('data')"
          [addRowValid]="checkValid()"
          [coOwnerIndividuals]="coOwnerIndividuals"
          [error]="error"
          (emitValidate)="coOwnerValidate($event)"
          (errorMessage)="getErrorMessage($event)"
          [coOwnerIndivErrorMessage]="coOwnerIndivErrorMessage"
          (removeRow)="removeRow($event)"
          (addRow)="addRow()"
        ></nh-co-owner>
      </div>
      }
    </div>
    }
  </section>
</nh-form>